import React from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';
import { Grid } from '../../app/StyleGuide';
import ErrorMessage from '../../components/ErrorMessage';
import { DisciplesPathView } from './components/DisciplesPathView';

const CenteredContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const PageContainer = styled(CenteredContainer)`
  position: relative;
  padding-bottom: ${Grid._10};
  flex-direction: column;
  align-items: center;

  h1 {
    margin: ${Grid._6} 0 ${Grid._5} 0;
  }
`;

const ErrorContainer = styled.div`
  width: 100%;
`;

export const ContactInitiative = () => {
  const { initiative } = useParams<{ initiative: 'disciples-path' }>();

  const renderInitiativeView = () => {
    switch (initiative) {
      case 'disciples-path':
        return <DisciplesPathView />;
      default:
        return (
          <ErrorContainer>
            <ErrorMessage>Initiative not found.</ErrorMessage>;
          </ErrorContainer>
        );
    }
  };

  return <PageContainer>{renderInitiativeView()}</PageContainer>;
};
